import { CookiesService } from 'src/app/cookies/cookies.service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from './utils.service';
import { ErrorsService } from './errors.service';

declare var ga;

@Injectable({
  providedIn: 'root'
})
export class ExperimentsService {

  experimentsCache: Array<boolean> = [];

  constructor(
    private cookiesService: CookiesService,
    private utilsService: UtilsService,
    private errorsService: ErrorsService
  ) { }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  isCTAVariant() {
    return false;
    // return this.isExperimentVariant(environment.experimentIds.CTA);
  }

  isHomeSearchVariant() {
    return false;
    // return this.isExperimentVariant(environment.experimentIds.homeSearch);
  }

  isRecommendedResultsVariant() {
    return this.isExperimentVariant(environment.experimentIds.recommendedResults, true);
  }

  isPopupShoppingCartVariant() {
    // This experiment doesn't need and can't run in the server, as we need to
    // obtain the window size to determine if the user can access the test or not.
    return false;
    // if (this.utilsService.isBrowser) {
    //   const isDesktop = window.innerWidth > this.popupMinWindowWidth;
    //   const hidePopup = localStorage.getItem('hideCartPopup') === 'true';
    //   return isDesktop && !hidePopup && this.isExperimentVariant(environment.experimentIds.popupShoppingCart);
    // } else {
    //   return false;
    // }
  }

  hidePopupShoppingCartVariant() {
    localStorage.setItem('hideCartPopup', 'true');
  }

  isPopupAddedToCartVariant() {
    // This experiment doesn't need and can't run in the server, as we need to
    // obtain the window size to determine if the user can access the test or not.
    return false;
    // if (this.utilsService.isBrowser) {
    //   const isDesktop = window.innerWidth > this.popupMinWindowWidth;
    //   return isDesktop && this.isExperimentVariant(environment.experimentIds.popupAddedToCart);
    // } else {
    //   return false;
    // }
  }

  isRecommendationEmptyCartVariant() {
    if (environment.tag === 'staging') {
      return true;
    }
    return this.isExperimentVariant(environment.experimentIds.recommendationsInEmptyCart);
  }

  isExperimentVariant(experimentId: string, forceValue: boolean = null) {
    if (forceValue !== null) {
      this.experimentsCache[experimentId] = forceValue;
      this.setAnalyticsExperiments();
      return forceValue;
    }

    if (this.experimentsCache.hasOwnProperty(experimentId)) {
      return this.experimentsCache[experimentId];
    }

    let result = false;
    if (this.cookiesService.isSet(experimentId)) {
      result = this.cookiesService.get(experimentId) === 'true';
    } else {
      const variant = this.getRandomInt(2);
      if (variant) {
        this.cookiesService.put(experimentId, 'true');
        result = true;
      } else {
        this.cookiesService.put(experimentId, 'false');
        result = false;
      }
    }

    this.experimentsCache[experimentId] = result;
    this.setAnalyticsExperiments();
    return result;
  }

  setAnalyticsExperiments() {
    if (this.utilsService.isBrowser) {
      try {
        let exp = '';
        Object.values(environment.experimentIds).forEach(id => {
          if (this.cookiesService.isSet(id)) {
            if (exp !== '') {
              exp += '!';
            }
            exp += id;
            exp += '.';
            exp += this.cookiesService.get(id) === 'true' ? '1' : '0';
          }
        });
        let gtag = environment.gtag;
        gtag = gtag.split('-').join('_');
        ga('gtag_' + gtag + '.set', 'exp', exp);
      } catch (e) {
        this.errorsService.track(e);
      }
    }
  }
}



